import React, { useContext, useCallback } from 'react';
import { EmailProvider } from '@mummssoftware/common-ui';
import { GlobalContext, SET_EMAIL_LIST } from '@mummssoftware/global-context';
import { getSiteEmailList } from '@mummssoftware/utils/pimReader';
import { isAgencyEnabled, getUserName } from '@mummssoftware/utils/utils';
import { Context } from '../../context';

type DashboardEmailProviderProps = {
  children: React.ReactNode;
};

export const DashboardEmailProvider = ({
  children,
}: DashboardEmailProviderProps) => {
  const { siteEmailList, dispatch } = useContext(GlobalContext);
  const { keycloak, agency, currentUser } = useContext(Context);

  const fetchEmailList = useCallback(async () => {
    if (!agency || !keycloak) return;
    const response = await getSiteEmailList(agency, keycloak);
    dispatch({
      type: SET_EMAIL_LIST,
      payload: response,
    });
  }, [agency, keycloak, dispatch]);

  const isEmailEnabled = !!isAgencyEnabled(
    window.env?.emailAgency,
    currentUser,
  );
  const getSenderName = useCallback(() => getUserName(currentUser), [
    currentUser,
  ]);

  const config = {
    siteEmailList: siteEmailList ?? null,
    fetchEmailList,
    isEmailEnabled,
    getSenderName,
  };

  return <EmailProvider config={config}>{children}</EmailProvider>;
};
